module.exports = __webpack_public_path__ + "static/media/fullscreen-exit.4ddeda53.svg";